import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftTeamsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.693 12.476h-6.846c-.726 0-.559.617-.559 1.343v6.656a4.356 4.356 0 1 0 8.711 0V13.82a1.32 1.32 0 0 0-1.306-1.343m-3.063-1.25c1.612 0 2.919-1.336 2.919-2.984S27.242 5.26 25.63 5.26c-1.611 0-2.918 1.336-2.918 2.983s1.306 2.984 2.918 2.984",
			fill: "#5059c9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9 12.476h11.376a1.33 1.33 0 0 1 1.314 1.343v8.145a7.085 7.085 0 0 1-7.006 7.157 7.08 7.08 0 0 1-6.998-7.15v-8.152a1.32 1.32 0 0 1 1.307-1.343zm5.684-1.249c2.257 0 4.087-1.869 4.087-4.174s-1.83-4.174-4.087-4.174-4.087 1.868-4.087 4.174 1.83 4.174 4.087 4.174",
			fill: "#7b83eb"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .67,
			fill: "#000",
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M10.901 12.476a1.32 1.32 0 0 0-1.314 1.335v8.145a7.1 7.1 0 0 0 .806 3.332h4.435a1.16 1.16 0 0 0 1.176-1.147V12.476z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145c0 .85.15 1.693.443 2.49h4.798a1.16 1.16 0 0 0 1.176-1.147V12.476zm5.081-1.314a1.154 1.154 0 0 0-1.154-1.053h-1.002a3.96 3.96 0 0 0 2.156 1.053"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145c.002.585.072 1.167.21 1.735H16.1a.883.883 0 0 0 .87-.9V12.476zm2.018-3.616a4.05 4.05 0 0 0 3.63 2.36q.195.009.384-.037V9.768a.885.885 0 0 0-.87-.893z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M13.121 9.238a4.02 4.02 0 0 0 3.463 1.982q.192.009.377-.037v-1.03a.885.885 0 0 0-.87-.893h-2.97zM10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145c-.001.67.089 1.337.269 1.982l6.127.08a1.07 1.07 0 0 0 .98-.995V12.447z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .01,
					d: "M15.974 11.162V9.07a.885.885 0 0 0-.879-.893h-2.424a4.09 4.09 0 0 0 3.303 2.984M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.102l4.61-.625c.486 0 1.778-.428 1.778-.921v-7.891z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145a7.3 7.3 0 0 0 .617 2.904h4.646a1.16 1.16 0 0 0 1.169-1.154v-11.23zm4.973-1.329a1.18 1.18 0 0 0-1.045-.624h-.53a3.9 3.9 0 0 0 1.575.624"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M10.901 12.476a1.32 1.32 0 0 0-1.314 1.335v8.145q-.003.677.123 1.343h5.126a1.17 1.17 0 0 0 1.168-1.154v-9.67zm5.103-1.307v-.777a1.16 1.16 0 0 0-1.17-1.147H13.13a4.05 4.05 0 0 0 2.904 1.924z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145q.002.637.116 1.264h5.133a1.17 1.17 0 0 0 1.176-1.155v-9.59zm5.104-1.307v-.777a1.16 1.16 0 0 0-1.176-1.147h-1.7a4.05 4.05 0 0 0 2.876 1.924"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145c0 .653.088 1.302.261 1.931h4.98a1.17 1.17 0 0 0 1.169-1.154V12.476zm5.103-1.307v-.48a1.176 1.176 0 0 0-1.175-1.16h-1.496a4.07 4.07 0 0 0 2.671 1.64"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M10.901 12.476a1.32 1.32 0 0 0-1.314 1.335v8.145a6.9 6.9 0 0 0 .341 2.178h4.9a1.16 1.16 0 0 0 1.176-1.154V12.476zm5.103-1.307v-.218a1.16 1.16 0 0 0-1.168-1.147h-1.3a4.07 4.07 0 0 0 2.468 1.365"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M16.585 11.22h.224v-.66a.886.886 0 0 0-.87-.894h-2.527a4 4 0 0 0 3.172 1.576zm.225 1.256H10.9a1.32 1.32 0 0 0-1.313 1.335v8.145c0 .56.066 1.118.196 1.663h6.156a.88.88 0 0 0 .878-.879z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145q0 .688.13 1.365h5.547a.885.885 0 0 0 .878-.886v-9.96zm5.242-1.3v-.617a.89.89 0 0 0-.878-.9H13.39a4.04 4.04 0 0 0 2.75 1.517"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M16.236 11.19v-1.037c0-.523-1.183-.82-1.314-.973a2.5 2.5 0 0 0-1.248-.312h-.799a4.07 4.07 0 0 0 3.361 2.323M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.145a7 7 0 0 0 .05.886h5.758a.88.88 0 0 0 .87-.886v-9.48z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M16.519 11.212a.88.88 0 0 0-.864-.885h-1.597c.7.583 1.579.908 2.49.922zm-5.618 1.264a1.32 1.32 0 0 0-1.314 1.335v8.145a7 7 0 0 0 .378 2.309h5.684a.88.88 0 0 0 .87-.886V12.49z"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.32l4.602-.625c.487 0 1.779-.428 1.779-.922v-8.087zm5.075-1.314v-1.83a.885.885 0 0 0-.872-.9h-2.359a4.1 4.1 0 0 0 3.23 2.73"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .15,
					d: "M15.974 11.162V9.55a.886.886 0 0 0-.87-.893h-2.288a4.1 4.1 0 0 0 3.158 2.505M10.9 12.476a1.32 1.32 0 0 0-1.313 1.335v8.537l4.588-.617c.486 0 1.786-.435 1.786-.922v-8.333z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.169 8.839h11.673a1.183 1.183 0 0 1 1.169 1.19v11.935a1.184 1.184 0 0 1-1.169 1.19H3.169A1.174 1.174 0 0 1 2 21.964V10.029A1.183 1.183 0 0 1 3.17 8.84",
			fill: "#4b53bc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.476 13.289H9.863v7.18h-1.72v-7.18H5.52v-1.764h6.955z",
			fill: "#fff"
		})
	]
});
export default SvgMicrosoftTeamsRegularIcon;
